"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Languages = _interopRequireDefault(require("../constants/Languages"));

var DEFAULT_LANGUAGE = 'en';
var _default = {
  isLanguageSupported: function isLanguageSupported(language) {
    return Object.keys(_Languages.default).indexOf(language) >= 0;
  },

  /**
   * E.g. de, en, es (default is en)
   */
  getUserLanguage: function getUserLanguage() {
    var userLanguage = window.I18N_MANUAL_LANG;
    return this.isLanguageSupported(userLanguage) ? userLanguage : DEFAULT_LANGUAGE;
  },

  /**
   * E.g. Deutsch, English, Español
   */
  getPrintUserLanguage: function getPrintUserLanguage() {
    var userLanguage = this.getUserLanguage();
    return _Languages.default[userLanguage];
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/util/LanguageUtil.js
// module id = 50
// module chunks = 0